import { useState, useEffect } from "react";
import HelpWantedModal from "../Dashboard/HelpWantedModal";
import config from "../../config";
import { useLocation } from "react-router-dom";
import { Capacitor, Plugins } from "@capacitor/core";
import queryString from "query-string";
import Cookies from "js-cookie";

const HelpWanted = () => {
  const [profiles, setProfiles] = useState();
  const [helpWantedData, setHelpWantedData] = useState();
  const location = useLocation();
  const loginToken = Capacitor.isNativePlatform()
    ? params.token
    : Cookies.get("LoginToken"); // => 'value'

  let params = queryString.parse(location.search);

  useEffect(() => {
    fetch(`${config.genni.marketing_portal.API_KEY}/creatorapi/helpwanted`, {
      method: "GET",
      headers: { "Content-Type": "application/json", "x-api-key": loginToken },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw res;
        //const jsonRes = JSON.parse(res);
      })
      .then((d) => {
        d?.data.map((obj) => {
          if (obj.ExploreSurveyID === parseInt(params.ID)) {
            setHelpWantedData(obj);
          }
        });
      });
  }, []);
  useEffect(() => {
    if (!profiles) {
      fetch(
        `${config.genni.marketing_portal.API_KEY}/creatorapi/profiles?x-api-key=${loginToken}`,
        {
          method: "GET",
        }
      )
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            window.location.href = `/login?returnTo=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;
          }
          //const jsonRes = JSON.parse(res);
        })
        .then((data) => {
          setProfiles(data);
        });
    }
  }, []);
  return (
    <>
      <div className="container mt-4">
        {helpWantedData && profiles && (
          <HelpWantedModal
            activeCard={helpWantedData}
            setActiveCard={setHelpWantedData}
            profiles={profiles}
            isModal={false}
          />
        )}
      </div>
    </>
  );
};

export default HelpWanted;
